import { Tabs, Tab } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

const ClientTabs = ({ clientId }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const tabMap = [
        { path: '', label: '基本情報' },
        { path: 'prices', label: '価格設定' },
        { path: 'billing', label: '請求設定' },
    ];

    const currentIndex = tabMap.findIndex(tab =>
        location.pathname.endsWith(`/clients/${clientId}${tab.path ? '/' + tab.path : ''}`)
    );

    const value = currentIndex === -1 ? 0 : currentIndex;

    return (
        <Tabs
            value={value}
            onChange={(e, newValue) => {
                const target = tabMap[newValue].path;
                navigate(
                    target
                        ? `/clients/${clientId}/${target}`
                        : `/clients/${clientId}`
                );
            }}
            sx={{ mb: 2 }}
        >
            {tabMap.map(tab => (
                <Tab key={tab.path} label={tab.label} />
            ))}
        </Tabs>
    );
};

export default ClientTabs;